// eslint-ignore
export default 
`<Checkbox
  v-model="allSelected"
  :indeterminate="indeterminate"
  @change="toggleAll"        
>
  {{ allSelected ? 'Unselect All' : 'Select All' }}
</Checkbox>


<Checkbox 
  v-model="selected"
  v-for="fruit in fruits" 
  :fruit="fruit" 
  :key="fruit.value" 
  :text="fruit.text"
  :value="fruit.value"
>
</Checkbox>


<p>Selected:{{ selected }}</p>
<p>All Selected:{{ allSelected }}</p>
<p>Indeterminate:{{ indeterminate }}</p>



export default {
  components: {
    Checkbox
  },

  data () {
    return {
      selected: [],
      allSelected: false,
      indeterminate: false
    }
  },

  methods: {
    toggleAll(checked) {
        let result = this.fruits.map(({ value }) => value)
        this.selected = checked ? result : []
    }
  },

  watch: {
    selected(newValue) {
      // Handle changes in individual fruit checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.fruits.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  }
}`;